/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Settings_DescriptionInputs */

const en_disabled_websites_settings_description = /** @type {(inputs: Disabled_Websites_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure how websites are disabled`)
};

const es_disabled_websites_settings_description = /** @type {(inputs: Disabled_Websites_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura cómo se deshabilitan los sitios`)
};

/**
* | output |
* | --- |
* | "Configure how websites are disabled" |
*
* @param {Disabled_Websites_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_settings_description = /** @type {((inputs?: Disabled_Websites_Settings_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Settings_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_settings_description(inputs)
	return en_disabled_websites_settings_description(inputs)
});